import { useEffect } from "react";
import { createKeyboardNavigation } from "./keyboard-navigation";

export const useKeyboardNavigation = () => {
  const {
    handleKeyDown,
    handleTabKeyNavigation,
    setupTabNavigation
  } = createKeyboardNavigation();

  useEffect(() => {
    const cleanup = setupTabNavigation();
    return cleanup;
  }, []);

  return {
    handleKeyDown
  };
};

